<template>
    <div class="container-fluid">
        <section class="content-header">
                <div class="row mb-2">
                    <h3>{{ $t('general.listadoperitos') }}</h3>
                </div>
        </section>
        <section class="content">
            <div class="row">
                <div class="col-md-2">
                    <peritos-estados />
                </div>
                <div class="col-md-10">
                    <tabla-datos :columnas="columnas" :datos="datos" :filtros="filtros" :filtrosBuscador="filtrosBuscador" :total="total" @quieroDatos="obtenerDatos($event)"></tabla-datos>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import PeritosEstados from './listado/PeritosEstados.vue'
import TablaDatos from '../../TablaDatos.vue'
import { PwgsApi } from '../../../services/PwgsApi.js'
export default {
    components: {
        'peritos-estados': PeritosEstados,
        TablaDatos,
    },
    props: {
        id: {
            type: Number,
            default: 0,
          }
      },
    data() {
        return {
            datos: [],
            eliminado: false,
            parametros: null,
            total:'',
            filtrosBuscador: ['nombre', 'empresa', 'email'], // filtros para el buscador
            filtros: { // filtros de columna
                'nombre': { value: '', matchMode: 'contains' },
                'empresa': { value: '', matchMode: 'contains' },        
            },
            columnas:[
               {
                    header: 'Nombre',
                    field: 'nombre',
                    sortable: true,
                    acciones: [
                        {
                            link: true,
                            tipo: 'default',
                            nombreId: 'idperito',
                            // Debe ser arrow function para que this sea este componente
                            accion: (id) => {
                                this.$router.push({
                                    name: 'Perito',
                                    params: {
                                        id:id
                                    }
                                });
                            }
                        },
                    ]
                },
                {
                    header: 'Empresa',
                    field: 'empresa',
                    sortable: true,
                },
                {
                    header: 'Telefono',
                    field: 'telefono1',
                },
                {
                    header: 'Email',
                    field: 'email',
                },
                {
                    header: 'Acciones',
                    data: null,
                    acciones: [
                        {
                            nombre: 'Editar',
                            class: 'editar',
                            tipo: 'default',
                            nombreId: 'idperito',
                            icono: 'far fa-edit',
                            // Debe ser arrow function para que this sea este componente
                            accion: (id) => {
                                this.$router.push({
                                    name: 'Perito',
                                    params: {
                                        id:id
                                    }
                                });
                            }
                        },
                        {
                            nombre: 'Eliminar',
                            class: 'eliminar',
                            tipo: 'danger',
                            nombreId: 'idperito',
                            icono: 'far fa-trash-alt',
                            // Debe ser arrow function para que this sea este componente
                            accion: (id) => {
                                if (confirm('Desea eliminar el perito')) {
                                    this.eliminar(id);
                                    this.eliminado = true;
                                }
                            }
                        },
                    ]
                }
            ]
        }
    },
    methods: {
        async obtenerDatos(parametros) {
            const api = new PwgsApi();
            const params = parametros;
            this.$store.dispatch('cambiarCargando', true);
            const datos = await api.get('peritos', params); 
            this.datos = datos.datos;
            this.total = datos.n_total_registros;
            this.eliminado = false;
            this.columnas[0].header = this.$t("general.nombre");
            this.columnas[1].header = this.$t("general.empresa");
            this.columnas[2].header = this.$t("general.telefono");
            this.columnas[4].header = this.$t("general.acciones");
            this.$store.dispatch('cambiarCargando', false);
        },
        async eliminar(id) {
            const api = new PwgsApi();
            await api.delete('peritos/' + id);  
        }
    },
    watch: {
      eliminado() {
       this.obtenerDatos(this.parametros);
        }
     },
  
}
</script>
<style>
.p-dialog {
    width: 90%;
}
</style>